import { render, staticRenderFns } from "./EconomicPerformance.vue?vue&type=template&id=2861d7f8"
import script from "./EconomicPerformance.vue?vue&type=script&lang=js"
export * from "./EconomicPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports